__turbopack_context__.v({
  "bg": "studio-section-module__VHZa4G__bg",
  "bottomBlockTitle": "studio-section-module__VHZa4G__bottomBlockTitle",
  "bottomBlockWrapper": "studio-section-module__VHZa4G__bottomBlockWrapper",
  "bottomCards": "studio-section-module__VHZa4G__bottomCards",
  "bottomCardsText": "studio-section-module__VHZa4G__bottomCardsText",
  "bottomCardsWrapper": "studio-section-module__VHZa4G__bottomCardsWrapper",
  "bottomDisabledCards": "studio-section-module__VHZa4G__bottomDisabledCards",
  "bottomDisabledCardsText": "studio-section-module__VHZa4G__bottomDisabledCardsText",
  "buttonWrapper": "studio-section-module__VHZa4G__buttonWrapper",
  "cardCenteredText": "studio-section-module__VHZa4G__cardCenteredText",
  "cardText": "studio-section-module__VHZa4G__cardText",
  "cardTitle": "studio-section-module__VHZa4G__cardTitle",
  "cardsRowWrapper": "studio-section-module__VHZa4G__cardsRowWrapper",
  "centeredCard": "studio-section-module__VHZa4G__centeredCard",
  "comingSoonText": "studio-section-module__VHZa4G__comingSoonText",
  "create3dTitle": "studio-section-module__VHZa4G__create3dTitle",
  "defaultText": "studio-section-module__VHZa4G__defaultText",
  "defaultWebText": "studio-section-module__VHZa4G__defaultWebText",
  "gamingTechDescription": "studio-section-module__VHZa4G__gamingTechDescription",
  "gamingTechImage": "studio-section-module__VHZa4G__gamingTechImage",
  "gamingTechTextWrapper": "studio-section-module__VHZa4G__gamingTechTextWrapper",
  "gamingTechTitle": "studio-section-module__VHZa4G__gamingTechTitle",
  "gif": "studio-section-module__VHZa4G__gif",
  "gifWrapper": "studio-section-module__VHZa4G__gifWrapper",
  "grayText": "studio-section-module__VHZa4G__grayText",
  "grayWebText": "studio-section-module__VHZa4G__grayWebText",
  "highlightedCardWord": "studio-section-module__VHZa4G__highlightedCardWord",
  "highlightedStudioWord": "studio-section-module__VHZa4G__highlightedStudioWord",
  "highlightedWord": "studio-section-module__VHZa4G__highlightedWord",
  "liveServicesImage": "studio-section-module__VHZa4G__liveServicesImage",
  "liveServicesSectionsRoot": "studio-section-module__VHZa4G__liveServicesSectionsRoot",
  "liveServicesTextWrapper": "studio-section-module__VHZa4G__liveServicesTextWrapper",
  "mainContentWrapper": "studio-section-module__VHZa4G__mainContentWrapper",
  "mpGif": "studio-section-module__VHZa4G__mpGif",
  "mpGifWpapper": "studio-section-module__VHZa4G__mpGifWpapper",
  "parWrapper": "studio-section-module__VHZa4G__parWrapper",
  "root": "studio-section-module__VHZa4G__root",
  "sectionBottomContent": "studio-section-module__VHZa4G__sectionBottomContent",
  "sectionBottomContentTitle": "studio-section-module__VHZa4G__sectionBottomContentTitle",
  "sectionContent": "studio-section-module__VHZa4G__sectionContent",
  "sectionMiddleContent": "studio-section-module__VHZa4G__sectionMiddleContent",
  "sectionMiddleContentTitle": "studio-section-module__VHZa4G__sectionMiddleContentTitle",
  "sectionTopContent": "studio-section-module__VHZa4G__sectionTopContent",
  "studioCardsWrapper": "studio-section-module__VHZa4G__studioCardsWrapper",
  "studioMiddleCard": "studio-section-module__VHZa4G__studioMiddleCard",
  "studioSectionDivider": "studio-section-module__VHZa4G__studioSectionDivider",
  "studioSectionGif": "studio-section-module__VHZa4G__studioSectionGif",
  "studioSectionSubtitle": "studio-section-module__VHZa4G__studioSectionSubtitle",
  "studioSectionText": "studio-section-module__VHZa4G__studioSectionText",
  "studioSectionTitle": "studio-section-module__VHZa4G__studioSectionTitle",
  "studioSectionTopContent": "studio-section-module__VHZa4G__studioSectionTopContent",
  "studioSvgWrapper": "studio-section-module__VHZa4G__studioSvgWrapper",
  "studioZepetoWrapper": "studio-section-module__VHZa4G__studioZepetoWrapper",
  "textBlockTitle": "studio-section-module__VHZa4G__textBlockTitle",
  "textWrapper": "studio-section-module__VHZa4G__textWrapper",
  "title": "studio-section-module__VHZa4G__title",
  "unifiedBuilderImage": "studio-section-module__VHZa4G__unifiedBuilderImage",
  "uniqueSectionButtonWrapper": "studio-section-module__VHZa4G__uniqueSectionButtonWrapper",
  "uniqueSectionImage": "studio-section-module__VHZa4G__uniqueSectionImage",
  "unitedSectionsTitle": "studio-section-module__VHZa4G__unitedSectionsTitle",
  "web3SectionImage": "studio-section-module__VHZa4G__web3SectionImage",
  "web3SectionRoot": "studio-section-module__VHZa4G__web3SectionRoot",
  "web3TextWrapper": "studio-section-module__VHZa4G__web3TextWrapper",
  "zepetoButtonWrapper": "studio-section-module__VHZa4G__zepetoButtonWrapper",
});
